import React, { useState, useEffect } from 'react';
import { Badge, Button, SpaceBetween } from '@cloudscape-design/components';

function formatElapsed(cachedAt) {
  if (!cachedAt) return '';
  const diff = Math.floor((Date.now() - cachedAt.getTime()) / 1000);
  const d = Math.floor(diff / 86400);
  const h = Math.floor((diff % 86400) / 3600);
  const m = Math.floor((diff % 3600) / 60);
  const s = diff % 60;
  const pad = (n) => String(n).padStart(2, '0');
  if (d > 0) return `${pad(d)}:${pad(h)}:${pad(m)}:${pad(s)}`;
  return `${pad(h)}:${pad(m)}:${pad(s)}`;
}

export default function CacheIndicator({ cachedAt, isCached, loading, onRefresh }) {
  const [, setTick] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => setTick(t => t + 1), 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <SpaceBetween direction="horizontal" size="xs" alignItems="center">
      {cachedAt && (
        <Badge color="blue">
          Cached · {formatElapsed(cachedAt)} ago
        </Badge>
      )}
      <Button variant="normal" iconName="refresh" loading={loading} onClick={onRefresh}>
        Refresh
      </Button>
    </SpaceBetween>
  );
}
